import { render, staticRenderFns } from "./PreambleCard.vue?vue&type=template&id=0e0b5ee2&scoped=true&"
import script from "./PreambleCard.vue?vue&type=script&lang=ts&"
export * from "./PreambleCard.vue?vue&type=script&lang=ts&"
import style0 from "./PreambleCard.vue?vue&type=style&index=0&id=0e0b5ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0b5ee2",
  null
  
)

export default component.exports